<template>
  <div class="third-party-auth-container">
    <div class="auth-third-party">
      <!-- <div class="auth-third-party-icon">
        <img src="../../assets/img/google-icon.svg" @click="google" />
      </div> -->
      <!-- <div class="auth-third-party-icon">
        <img src="../../assets/img/facebook-icon.svg" />
      </div>
      <div class="auth-third-party-icon">
        <img src="../../assets/img/twitter-icon.svg" />
      </div>-->
      <!-- <div class="auth-third-party-icon" @click="discord">
        <img src="../../assets/img/discord-icon.svg" />
      </div> -->
    </div>
    <!-- <div class="auth-option-tag">{{ optionText }}</div> -->
  </div>
</template>

<script>
export default {
  props: {
    optionText: String,
    type: String,
  },
  methods: {
    discord() {
      if (this.type === "login")
        window.open(
          "https://user.resolved.gg/api/v1/client/user/dashboard/auth/login/oauth/discord",
          "_self"
        );
      else
        window.open(
          "https://user.resolved.gg/api/v1/client/user/dashboard/auth/register/oauth/discord",
          "_self"
        );
    },
    google() {
      if (this.type === "login")
        window.open(
          "https://user.resolved.gg/api/v1/client/user/dashboard/auth/login/oauth/google",
          "_self"
        );
      else
        window.open(
          "https://user.resolved.gg/api/v1/client/user/dashboard/auth/register/oauth/google",
          "_self"
        );
    },
  },
};
</script>

<style scoped>
.third-party-auth-container {
  width: 100%;
}
.auth-third-party {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  max-width: 100px;
  margin: auto;
  margin-top: 24px;
  margin-bottom: 24px;
  height: 50px;
}
.auth-third-party-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: 1.33px solid #131517;
  cursor: pointer;
}
.auth-option-tag {
  font-size: 12px;
  color: #888888;
  font-family: "OpenSans";
  text-align: center;
  margin-bottom: 24px;
}
</style>
